var exports = {
  "J4": "CommentLoadingContainer__DuF8Ac",
  "C7": "CommentLoadingContentWrapper__5b-reE",
  "o3": "CommentLoadingCard__lg1N03",
  "zm": "CommentLoadingHeader__kYSnlF",
  "nU": "CommentLoadingContent__Xnvtxn",
  "BX": "avatarSkeleton__nMNYTl",
  "CB": "avatarSkeletonHiddenSmall__-xMO-z",
};

module.exports = exports;
